import { RailHoles } from "../../../shared";
import { ItemsPos } from "../../types/store";
import { useShelvingStore } from "../../useShelvingStore";
import { useStoreSystem } from "../../useStoreSystem";
import { findSectionIndex } from "./calcItemPosition";

export const checkPositionErrors = (id: string, position: number[]): boolean => {
    const currentShelving = useShelvingStore.getState().getCurrentShelving();
    const currentSideSections = structuredClone(currentShelving.sections);
    const currentSectionId = useStoreSystem.getState().currentSectionId;
    const currentSectionIndex = currentSideSections.findIndex((section) => section.id === currentSectionId);
    const currentItem = currentSideSections[currentSectionIndex].items.find((item) => item.id === id);

    if (!currentItem || !currentShelving.itemsYPos) return true;

    const y = position[1];

    const diffValue = 25 / 1000;
    const newSectionIndex = findSectionIndex(id, position[0]);

    if (newSectionIndex === null) return true;

    const intersectionCondition = (hole: RailHoles, yPos: ItemsPos, index: number, depth: number) => {
        if (Math.abs(Math.trunc((y + 0.05 * hole.sort) * 1000) / 1000 - yPos.positionY) < diffValue) {
            if (yPos.depthTo !== undefined && yPos.depthFrom !== undefined && yPos.name !== currentItem.name) {
                if (hole.depthTo > yPos.depthTo || hole.depthFrom < yPos.depthFrom || depth > yPos.depthTo) {
                    return true;
                }
            }
            if (newSectionIndex === yPos.sectionIndex) {
                if (
                    (hole.leftRightRail && yPos.leftRightRail) ||
                    (hole.leftLeftRail && yPos.leftLeftRail) ||
                    (hole.rightRightRail && yPos.rightRightRail) ||
                    (hole.rightLeftRail && yPos.rightLeftRail)
                ) {
                    return true;
                }
            }
            if (newSectionIndex < yPos.sectionIndex) {
                if ((hole.leftRightRail && yPos.leftLeftRail) || (hole.rightRightRail && yPos.rightLeftRail)) {
                    return true;
                }
            }
            if (currentSectionIndex > yPos.sectionIndex) {
                if ((hole.rightLeftRail && yPos.rightRightRail) || (hole.leftLeftRail && yPos.leftRightRail)) {
                    return true;
                }
            }
        }
    };
    const leftElements = currentItem?.brackets?.left?.elements;

    const checkHoleIntersection = currentShelving.itemsYPos.find((yPos) => {
        let isIntersection = false;
        if (leftElements?.find((element) => element?.railHoles) && leftElements?.length) {
            for (let i = 0; i < leftElements.length; i++) {
                const element = leftElements[i];
                if (!element.railHoles) return;
                const railHoles = [...element.railHoles].reverse();
                if (!isIntersection) {
                    isIntersection = railHoles.some((hole, index) =>
                        intersectionCondition(hole, yPos, index, currentItem.depth)
                    );
                    if (isIntersection) {
                        return isIntersection;
                    }
                }
            }
        }

        if (currentItem?.railHoles) {
            const railHoles = [...currentItem?.railHoles].reverse();
            if (!isIntersection) {
                isIntersection = railHoles.some((hole, index) =>
                    intersectionCondition(hole, yPos, index, currentItem.depth)
                );
            }
        }
        return isIntersection;
    });

    const checkItemIntersection = currentShelving.itemsYPos.find((yPos) => {
        // console.log(y);
        if (Math.abs(Math.trunc((y - yPos.positionY) * 1000) / 1000) < diffValue) {
            if (!currentItem.type || !yPos.type) return false;

            if (
                currentItem.type.includes("shelf") &&
                yPos.type.includes("shelf") &&
                yPos.sectionIndex !== newSectionIndex &&
                !currentShelving.itemsYPos?.find(
                    (itemsYPos) => itemsYPos.positionY === y && itemsYPos.sectionIndex === newSectionIndex
                )
            ) {
                return true;
            }
        }
        return false;
    });

    if (checkHoleIntersection && !checkItemIntersection) {
        return true;
    }

    return false;
};
